import { Component, Prop, Vue } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CSubvencaoIRPJCSLL extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	form = {
		aliquotbase: 18,
		aliquotefetiva: 0,
		irpj: 25,
		csll: 9,
		months: 24,
		subvencaotype: '',
		monthlyConsumption: 0,
		diferenceIcms: '0,00',
		economicBenefit: 0,
		recuperation: 0,
	}

	advanced = {
		selic: 1.25,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: true,
	}

	options = {
		aliquot: [
			{ text: '18 a 21%', value: 8 },
			{ text: '21 a 25%', value: 9 },
			{ text: '25 a 30%', value: 10 },
			{ text: '> 30%', value: 12 },
		],
	}

	get selectedAliquot() {
		const option = this.options.aliquot.find((option) => {
			return this.form.aliquotefetiva === option.value
		})

		return option ? option.text : ''
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	switchType() {
		if (this.form.subvencaotype === 'Isenção') {
			this.form.aliquotbase = 0
			this.form.aliquotefetiva = 0
		}
	}

	// parse(n) {
	// 	if (isNaN(n)) return 0
	// 	n = parseFloat(n)
	// 	return parseFloat(n.toFixed(3))
	// }

	onInput() {
		let diferenceIcms = stringToNumber(this.form.diferenceIcms)

		if (this.form.subvencaotype !== 'Crédito presumido') {
			const monthlyConsumption = stringToNumber(
				this.form.monthlyConsumption,
			)
			const aliquotBasePerCent = this.form.aliquotbase / 100
			const aliquotEfetivaPerCent = this.form.aliquotefetiva / 100

			diferenceIcms =
				monthlyConsumption /
					(1 - aliquotBasePerCent + aliquotEfetivaPerCent) -
				monthlyConsumption
		}

		const irpjPerCent = this.form.irpj / 100
		const irpjAmount = diferenceIcms * irpjPerCent

		const csllPerCent = this.form.csll / 100
		const csllAmount = diferenceIcms * csllPerCent

		const economicBenefit = irpjAmount + csllAmount - diferenceIcms * 0.0925

		const recuperation = economicBenefit * this.form.months

		this.$emit('savings', economicBenefit)
		this.$emit('recuperate', recuperation)
		const recuperationFormat = currencyFormat(recuperation)
		const economicBenefitFormat = currencyFormat(economicBenefit)
		const diferenceFormat = currencyFormat(diferenceIcms)

		this.form.diferenceIcms = diferenceFormat
		this.form.economicBenefit = economicBenefitFormat
		this.form.recuperation = recuperationFormat
		this.save()
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.aliquotbase = this.form.aliquotbase
			found.aliquotefetiva = this.form.aliquotefetiva
			found.irpj = this.form.irpj
			found.csll = this.form.csll
			found.months = this.form.months
			found.subvencaotype = this.form.subvencaotype
			found.monthlyConsumption = this.form.monthlyConsumption
			found.diferenceIcms = this.form.diferenceIcms
			found.economicBenefit = this.form.economicBenefit
			found.recuperation = this.form.recuperation
		} else {
			this.calcsEach.unshift({
				id: this.id,
				aliquotbase: '',
				aliquotefetiva: '',
				irpj: '',
				csll: '',
				months: '',
				subvencaotype: '',
				monthlyConsumption: '',
				diferenceIcms: '',
				economicBenefit: '',
				recuperation: '',
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		let rows = () => [{}]
		if (this.form.subvencaotype === 'Crédito presumido') {
			rows = () => {
				return [
					[
						{
							label: 'Tipo de subvenção',
							value: this.form.subvencaotype,
						},
						{
							label: 'Crédito presumido de ICMS (mensal)',
							value: 'R$ ' + this.form.diferenceIcms,
						},
						{
							label: 'Benefício ecônomico',
							value: 'R$ ' + this.form.economicBenefit,
						},
						{
							label:
								'Recuperação (' + this.form.months + ') meses',
							value: 'R$ ' + this.form.recuperation,
						},
					],
				]
			}
		} else {
			rows = () => {
				return [
					[
						{
							label: 'Tipo de subvenção',
							value: this.form.subvencaotype,
						},
						{
							label: 'Faturamento Mensal',
							value: 'R$ ' + this.form.monthlyConsumption,
						},
						{
							label: 'Alíquota base de ICMS',
							value: this.form.aliquotbase + '%',
						},
						{
							label: 'Alíquota efetiva de ICMS',
							value: this.form.aliquotefetiva + '%',
						},
					],
					[
						{
							label: 'Diferença de ICMS',
							value: 'R$ ' + this.form.diferenceIcms,
						},
						{
							label: 'Benefício ecônomico',
							value: 'R$ ' + this.form.economicBenefit,
						},
						{
							label:
								'Recuperação (' + this.form.months + ') meses',
							value: 'R$ ' + this.form.recuperation,
						},
					],
				]
			}
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.form.recuperation
			found.savings = this.form.economicBenefit
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'Subvenção - Exclusão da base do IRPJ e CSLL',
				color: this.color,
				columns: 4,
				type: 'table',
				rows: rows(),
				recuperate: this.form.recuperation,
				savings: this.form.economicBenefit,
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.aliquotbase = this.form.aliquotbase
			found.aliquotefetiva = this.form.aliquotefetiva
			found.irpj = this.form.irpj
			found.csll = this.form.csll
			found.months = this.form.months
			found.subvencaotype = this.form.subvencaotype
			found.monthlyConsumption = this.form.monthlyConsumption
			found.diferenceIcms = this.form.diferenceIcms
			found.economicBenefit = this.form.economicBenefit
			found.recuperation = this.form.recuperation
		}
	}
}

function stringToNumber(value) {
	return parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
}
